/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {bulkUpdateBrands} from '../api'

export const useMutationBulkUpdateBrands = createReactQueryMutationHook('bulkUpdateBrands', bulkUpdateBrands)
